import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdowns",
  "use": "icon-dropdowns-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-dropdowns\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"m11.712 5.47 1.061 1.06L8 11.303 3.227 6.53l1.061-1.06L8 9.182z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol